import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import MainLayout from "./components/mainLayout";
import Dashboard from "./components/dashboard";
import { CssBaseline, } from '@mui/material';

import themes from './themes';
import List from "./components/masterManagement/list";
import CreatUser from "./components/masterManagement/createUser";
import MemberInfo from "./components/masterManagement/memberLimits";
import SubAccounts from "./components/subOwners/subAccounts";
import CreateSubAccount from "./components/subOwners/createSubAccount";
import Login from "./components/login/login";
import PrivateRoute from "./components/privateRoute";
import MemberDetail from "./components/masterManagement/memberDetail";
import EditUser from "./components/masterManagement/editUser";
import EditSubOwner from "./components/subOwners/editSubOwner"
import AddOdds from "./components/Odds/addOdds";
import ListOdds from "./components/Odds/listOdds";
import EditOdds from "./components/Odds/editOdds";
import Test from "./components/Odds/test";
import { pageContext } from './context';
import { useState } from "react";
import Leagues from "./components/reports/leagues";
import Teams from "./components/reports/teams";
import MatchResult from "./components/reports/matchResult";
import ParlayReport from "./components/reports/parlayReport";
import BodyReport from "./components/reports/bodyReport";
import MemberLimits from "./components/reports/memberLimits";
import AcceptedBetsHdp from "./components/bets/acceptedBetsHdp";
import AcceptedBetsParlay from "./components/bets/acceptedBetsParlay";
import RejectedBets from "./components/bets/rejectedBets";
import BetDetail from "./components/bets/betDetail";
import SlipDetailsEdit from "./components/bets/slipDetailsEdit";
import MatchResultEdit from "./components/reports/matchResultEdit";
import PointAdjustment from "./components/masterManagement/pointAdjustment";
import Statement from "./components/reports/statement";
import TwoThreeSettle from './components/reports/twoThreeSettle'
import Winners from "./components/reports/winners";
import TwoThreeStatements from "./components/reports/TwoThreeStatements";
import OddLogs from "./components/reports/oddLogs";
import MasterCommissions from "./components/masterManagement/masterCommissions";
import CommissionReport from "./components/masterManagement/commissionReport";
import DebtList from "./components/masterManagement/debtList";
import MemberDebtList from "./components/masterManagement/memberDebtList";
import Rules from "./components/masterManagement/rules";
import Slips from "./components/bets/slips";
import Noti from "./components/masterManagement/noti";
import socketIO from 'socket.io-client';
const socket = socketIO.connect('https://api.kl36.bet',{
  auth: {
      token: localStorage.getItem("token")
  },
});
function App() {
  const customization = useSelector((state) => state.customization);
  const [currentPages,setPages] = useState({masterManagementListPage: 1,subOwnerListPage: 1});

  const changePages = (pageObj) =>{
    setPages({...currentPages,...pageObj})
  }
  return (
    <pageContext.Provider value={{currentPages,changePages}}>
    <HashRouter>
      <ThemeProvider theme={themes(customization)}>
      <CssBaseline />
        <Routes>
         <Route path="/login" element={<Login/>}/>
         <Route element={<PrivateRoute/>}>
          <Route path="/" element={<MainLayout socket={socket}/>}>
            <Route path="/dashboard" element={<Dashboard />}/>
             <Route path="/master-management/list" element={<List />}/>
             <Route path="/master-management/list/memberDetail" element={<MemberDetail />}/>
             <Route path="/master-management/list/editUser" element={<EditUser />}/>
             <Route path="/master-management/createUser" element={<CreatUser />}/>
             <Route path="/master-management/pointAdjustment" element={<PointAdjustment />}/>
             <Route path="/master-management/rules" element={<Rules />}/>
             <Route path="/master-management/noti" element={<Noti />}/>
             <Route path="/master-management/memberInfo" element={<MemberInfo />}/>
             <Route path="/master-management/subAccounts" element={<SubAccounts />}/>
             <Route path="/master-management/subAccounts/editSubAccounts" element={<EditSubOwner />}/>
             <Route path="/master-management/createSubAccount" element={<CreateSubAccount/>}/>
             <Route path="/master-management/masterCommissions" element={<MasterCommissions/>}/>
             <Route path="/master-management/statements" element={<CommissionReport/>}/>
             <Route path="/master-management/debtList" element={<DebtList/>}/>
             <Route path="/master-management/memberDebtList" element={<MemberDebtList/>}/>
             <Route path="/odds/addOdds" element={<AddOdds/>}/>
             <Route path="/odds/listOdds" element={<ListOdds/>}/>
             <Route path="/odds/listOdds/editOdds" element={<EditOdds />}/>
             <Route path="/reports/statement" element={<Statement/>}/>
             <Route path="/reports/twoThreeSettle" element={<TwoThreeSettle/>}/>
             <Route path="/reports/winners" element={<Winners/>}/>
             <Route path="/reports/twoThreeStatements" element={<TwoThreeStatements/>}/>
             <Route path="/reports/leagues" element={<Leagues />}/>
             <Route path="/reports/teams" element={<Teams />}/>
             <Route path="/reports/matchResult" element={<MatchResult socket={socket}/>}/>
             <Route path="/reports/parlayReport" element={<ParlayReport/>}/>
             <Route path="/reports/bodyReport" element={<BodyReport/>}/>
             <Route path="/reports/matchResultEdit" element={<MatchResultEdit/>}/>
             <Route path="/reports/oddLogs" element={<OddLogs/>}/>
             <Route path="/reports/memberLimits" element={<MemberLimits/>}/>
             <Route path="/bets/acceptedBetsHdp" element={<AcceptedBetsHdp/>}/>
             <Route path="/bets/acceptedBetsParlay" element={<AcceptedBetsParlay/>}/>
             <Route path="/bets/rejectedBets" element={<RejectedBets/>}/>
             <Route path="/bets/rejectedBets" element={<RejectedBets/>}/>
             <Route path="/bets/slips" element={<Slips/>}/>
             <Route path="/bets/betDetails" element={<BetDetail/>}/>
             <Route path="/bets/slipDetails" element={<SlipDetailsEdit/>}/>
             <Route path="/test" element={<Test/>}/>
          </Route>
         </Route>
      </Routes>
      </ThemeProvider>
    </HashRouter>
    </pageContext.Provider>
  );
}

export default App;
